<script setup lang="ts">
import src from '~/assets/images/homepage/promo-iad.jpg';
</script>

<template>
  <HomeContentCard
    :src
    :alt="$t('homepage.promotion.alt_text')"
    class="pt-xl md:pt-2xl"
  >
    <IadTitle
      tag="p"
      :text="$t(`homepage.promo_iad.title`)"
    />
    <IadTitle
      variant="small"
      :text="$t(`homepage.promo_iad.description`)"
      tag="p"
    />
    <template #action>
      <IadBtn
        size="large"
        variant="outlined"
        :to="{ name: 'about' }"
        :text="$t(`core.navigation.discover_iad`)"
      />
    </template>
  </HomeContentCard>
</template>
